module.exports = __webpack_public_path__ + "static/img/logo_3.a06c09d4.png";